import * as msal from "@azure/msal-browser";
import {msalConfig} from "./authConfig";

// https://learn.microsoft.com/en-us/azure/active-directory-b2c/configure-authentication-sample-react-spa-app#step-1-configure-your-user-flow

export const msalInstance = new msal.PublicClientApplication(msalConfig);